import { render, staticRenderFns } from "./publicField.vue?vue&type=template&id=20af772a&"
import script from "./publicField.vue?vue&type=script&lang=js&"
export * from "./publicField.vue?vue&type=script&lang=js&"
import style0 from "./publicField.vue?vue&type=style&index=0&id=20af772a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports